import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthenticationProvider } from '../providers/authentication/authentication';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorLoggerService } from 'src/services/logging/error-logger.service';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {
    public currentUser;
    private AUTH_HEADER_TYPE = 'Bearer ';
    token: string;
    constructor(private authenticationService: AuthenticationProvider,
    private errorLogger: ErrorLoggerService
  ) {}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  // Skip logging API to prevent infinite loop
  if (req.headers.has('X-Skip-Interceptor')) {
    return next.handle(req);
  }

        this.currentUser = this.authenticationService.currentUserData();
        this.token = this.currentUser ? this.AUTH_HEADER_TYPE + this.currentUser.accessToken.token : null;
        req = this.addAuthenticationToken(req);
        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            // Handle token expired (refresh token expired)
            if (
                error.status === 400 &&
                error.error && error.error.type === 'tokenExpired'
               ) {
                if (this.authenticationService.isValidUser()) {
                this.authenticationService.logout();
                }
                return throwError(() => error);
            }

            // Handle unauthorized
            if (error.status === 401) {
                if (this.authenticationService.isValidUser()) {
                    this.authenticationService.logout();
                }
                return throwError(() => error);
            }

            // skip logging again
            if (req.url.toLowerCase().includes('error-logs')) {
              return throwError(error);
            }

            this.errorLogger.log({
              ErrorType: 'HttpError',
              Status: error.status,
              ErrorMessage: error.message,
              Url: req.url,
              Method: req.method,
              Route: req.urlWithParams,
              RawResponse: JSON.stringify(error.error),
            });

            // Sync logs asynchronously
            this.errorLogger.syncErrors()
              .catch(e => console.error('Error sync failed:', e));

            return throwError(() => error);
          })
        );
    }

    private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
        if (!request.url.includes(environment.apiUrl)) {
            return request;
        }
        const headers: { [header: string]: string } = {};
        const isSecurityQuestionUrl =
            request.url.includes('auth/security-questions') ||
            request.url.includes('reset-password/security-question');

        const isResetPasswordUrl = request.url.includes('me/auth/reset-password');
        if (this.token) {
            headers['Authorization'] = this.token;
        } else if (isResetPasswordUrl) {
            const localToken = localStorage.getItem('token');
            if (localToken) {
                headers['Authorization'] = 'Bearer ' + localToken;
            }
        }
        // App Key for all authenticated or anonymous API requests
        headers['X-APP-KEY'] = environment.appKey;

        // Anonymous language header for security questions
        if (!this.token && isSecurityQuestionUrl) {
            const lang = localStorage.getItem('anonymousUserLang');
            if (lang) {
                headers['Accept-Language'] = lang;
            }
        }
        return request.clone({ setHeaders: headers });
    }


}
